import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.e74_1 = partyId;
        this.f74_1 = playerId;
        this.g74_1 = name;
        this.h74_1 = email;
        this.i74_1 = badge;
        this.j74_1 = callSignAdjective;
        this.k74_1 = callSignNoun;
        this.l74_1 = imageURL;
        this.m74_1 = avatarType;
        this.n74_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.e74_1.toString() + ', playerId=' + this.f74_1.toString() + ', name=' + this.g74_1 + ', email=' + this.h74_1 + ', badge=' + this.i74_1.toString() + ', callSignAdjective=' + this.j74_1 + ', callSignNoun=' + this.k74_1 + ', imageURL=' + toString(this.l74_1) + ', avatarType=' + toString(this.m74_1) + ', unvalidatedEmails=' + toString(this.n74_1) + ')';
      }
      hashCode() {
        var result = this.e74_1.hashCode();
        result = imul(result, 31) + this.f74_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.g74_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h74_1) | 0;
        result = imul(result, 31) + this.i74_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.j74_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k74_1) | 0;
        result = imul(result, 31) + hashCode(this.l74_1) | 0;
        result = imul(result, 31) + hashCode(this.m74_1) | 0;
        result = imul(result, 31) + hashCode(this.n74_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.e74_1.equals(other.e74_1))
          return false;
        if (!this.f74_1.equals(other.f74_1))
          return false;
        if (!(this.g74_1 === other.g74_1))
          return false;
        if (!(this.h74_1 === other.h74_1))
          return false;
        if (!this.i74_1.equals(other.i74_1))
          return false;
        if (!(this.j74_1 === other.j74_1))
          return false;
        if (!(this.k74_1 === other.k74_1))
          return false;
        if (!equals(this.l74_1, other.l74_1))
          return false;
        if (!equals(this.m74_1, other.m74_1))
          return false;
        if (!equals(this.n74_1, other.n74_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
